import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('student');

export class StudentsWithoutBenefit extends Api {
  
  constructor(http, config = {}) {
    super(http, url, 'students-without-benefit', config);
  }
}
